import "./App.css";
import GameList from "./components/GameList";
import WishList from "./components/WishList";

function App() {
  return (
    <div className="App">
      <GameList />
      <WishList />
    </div>
  );
}

export default App;
